import { createStore } from "@stencil/store";
import { Getter } from "@stencil/store/dist/types";

export type User = {
  photo?: {
    _id: string,
    name: string
  },
  code: string,
  _class: { _id: string }
  login: string,
  name: string,
  token: string,
  exp: number,
} | null;
export interface IAuthState {
  error?: Error;
  isAuthenticated: boolean;
  isLoading: boolean;
  user?: User;
};

const authStore = createStore<IAuthState>({
  error: null,
  isAuthenticated: false,
  isLoading: typeof window !== 'undefined',
  user: null
});

export const reducer = (_state: IAuthState, action: { type: string, [k: string]: any }): void => {
  switch (action.type) {
    case "INITIALISED": {
      authStore.state.isLoading = true;
      authStore.state.isAuthenticated = false;
      break;
    };

    case "COMPLETE": {
      authStore.state.isLoading = false;
      authStore.state.isAuthenticated = !!(action.user);
      authStore.state.user = action.user;
      break;
    };

    case "ERROR": {
      authStore.state.isLoading = false;
      authStore.state.isAuthenticated = false;
      authStore.state.error = action.error;
      break;
    };

    case "LOGOUT": {
      authStore.state.isLoading = false;
      authStore.state.isAuthenticated = false;
      authStore.state.user = null;
      authStore.state.error = null;
      break;
    };
  }
};

export const dispatch = (action: {
  type: string
} & Partial<IAuthState>) => {
  reducer(authStore.state, action);;
};

export const getAuthState: Getter<IAuthState> = authStore.get;

